import { createSlice } from "@reduxjs/toolkit";
import {
  deleteCommityMember,
  getCommityMember,
  undoDeleteCommityMember,
} from "./CommityMember.api";

const commityMemberSlice = createSlice({
  name: "commityMember",
  initialState: {
    commityMember: {
      data: [],
      meta: {},
    },
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
    updateLocalOrder: (state, action) => {
      state.surname.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    // GET Banner FILTER WISE DATA
    builder.addCase(getCommityMember.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getCommityMember.fulfilled, (state, action) => {
      state.loading = false;
      state.commityMember = {
        data: action.payload.data, // Ensure this matches your API response
        meta: action.payload.meta,
      };
      state.dataLimit = action.payload.meta?.limit || 10;
      state.currentPage = action.payload.meta?.page || 1;
      state.totalPages = action.payload.meta?.totalPages || 0;
      state.totalData = action.payload.meta?.total || 0;
    });
    builder.addCase(getCommityMember.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteCommityMember.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteCommityMember.fulfilled, (state, action) => {
      const deletedId = action?.payload?.data?._id;
      if (state.commityMember.data && Array.isArray(state.commityMember.data)) {
        state.commityMember.data = state.commityMember.data.filter(
          (commityMember) => commityMember._id !== deletedId
        );
        // Update total count if needed
        state.totalData = state.totalData - 1;
      }
      state.loading = false;
    });
    builder.addCase(deleteCommityMember.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteCommityMember.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteCommityMember.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (state.commityMember.data) {
        state.commityMember.data = state.commityMember.data.filter(
          (commityMember) => {
            return commityMember._id !== undodeletedId;
          }
        );
        state.loading = false;
      } else {
        console.error(
          "state.commityMember.data is not an array:",
          state.commityMember.data
        );
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteCommityMember.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = commityMemberSlice.actions;
export default commityMemberSlice.reducer;
